import styled from "styled-components";

export const Content = styled.div`
  height: 200px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 10px;
  position: fixed; /* Alterado para fixed */
  z-index: 9999;
  overflow-y: auto; 

  .loader {
    overflow: visible;
    height: fit-content;
    width: fit-content;
    padding: 20px;
    display: flex;
  }

  .logo {
    fill: none;
    stroke-dasharray: 300px;
    stroke: black;
    animation: load 3s infinite ease-in-out;
  }

  @keyframes load {
    0% {
      stroke-dashoffset: 300px;
    }

    50% {
      stroke-dashoffset: 0px;
    }
    100% {
      stroke-dashoffset: 300px;
    }
  }
  
`;

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5); 
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9998; 
  
`;